// extracted by mini-css-extract-plugin
export var caqheading = "ParagraphCAQ-module--caqheading--36e12";
export var cards = "ParagraphCAQ-module--cards--79456";
export var paragraphcaq = "ParagraphCAQ-module--paragraphcaq--ad986";